import { IconListView } from '@xing-com/icons';

import * as Styled from '../styles';
import { type ToolProps } from '../types';

export const BulletListTool: React.FC<ToolProps> = ({ editor, disabled }) => {
  return (
    <Styled.ToolBarButton
      onClick={() => editor.chain().focus().toggleBulletList().run()}
      disabled={
        disabled || !editor.can().chain().focus().toggleBulletList().run()
      }
      className={editor.isActive('bulletList') ? 'is-active' : ''}
    >
      <IconListView width={24} height={24} />
    </Styled.ToolBarButton>
  );
};
